import { Controller } from '@hotwired/stimulus'

// Live "used / max" character counter for a text input or textarea. Reads the max
// from `maxValue` (or the field's own maxlength) and updates a count element on
// input. Generic + reusable: wrap a field group with
//   data-controller="char-counter" data-char-counter-max-value="150"
// tag the field with data-char-counter-target="field" + data-action="input->char-counter#update"
// and add a display element with data-char-counter-target="count".
export default class extends Controller {
  static targets = ['field', 'count']
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasFieldTarget || !this.hasCountTarget) return
    const max = this.maxValue || Number(this.fieldTarget.getAttribute('maxlength')) || 0
    const len = this.fieldTarget.value.length
    this.countTarget.textContent = max ? `${len} / ${max}` : String(len)
    // Warm the count when at the cap so it reads as a deliberate limit, not an error.
    this.countTarget.classList.toggle('text-accent', max > 0 && len >= max)
  }
}
